type permissionsUserType = 'officer' | 'admin';

export const permissionsKeys = {
  page: 'content-management.procedures',
  pageBlockFind: 'content-management.procedures.find',
  pageBlockCreate: 'content-management.procedures.create',
  pageBlockUpdate: 'content-management.procedures.update',
  pageBlockRemove: 'content-management.procedures.remove',
  pageBlockUpdatePublish: 'content-management.publish.procedures.update',
  pageBlockUpdateStatusToDraft: 'content-management.procedures.updateStatusToDraft',
  pageBlockUpdateInactivate: 'content-management.inactivate.procedures.update',
} as const;
